import { combineReducers } from 'redux';
import { addToPagination, createPagination } from 'redux/helpers/pagination';
import types from './types';

const allPulseSurveys = (state = createPagination(null, 'pulseSurveyIds'), { type, payload }) => {
  switch (type) {
    case types.getPulseSurveysSuccess:
      return addToPagination(state, null, payload, 'pulseSurveyIds');
    default:
      return state;
  }
};

const departments = (state = [], { type, payload }) => {
  switch (type) {
    case types.getDepartmentsSuccess:
      return payload;
    default:
      return state;
  }
};

const locations = (state = [], { type, payload }) => {
  switch (type) {
    case types.getLocationsSuccess:
      return payload;
    default:
      return state;
  }
};

const allPulseSurveyDetailedAnalytics = (
  state = createPagination(null, 'pulseSurveyDetailedAnalyticsGroupByValues'),
  { type, payload },
) => {
  switch (type) {
    case types.getPulseSurveyDetailedAnalyticsSuccess:
      return addToPagination(state, null, payload, 'pulseSurveyDetailedAnalyticsGroupByValues');
    default:
      return state;
  }
};

const pulseScales = (state = [], { type, payload }) => {
  switch (type) {
    case types.getPulseScalesSuccess:
      return payload.data;
    default:
      return state;
  }
};

const allPulseSurveyResponses = (state = createPagination(null, 'pulseSurveyResponseIds'), { type, payload }) => {
  switch (type) {
    case types.getPulseSurveyResponsesSuccess:
      return addToPagination(state, null, payload, 'pulseSurveyResponseIds');
    default:
      return state;
  }
};

const pulseSurveyPeriods = (state = [], { type, payload }) => {
  switch (type) {
    case types.getPulseSurveyPeriodsSuccess:
      return payload.data;
    default:
      return state;
  }
};

const pulseSurveySchedules = (state = [], { type, payload }) => {
  switch (type) {
    case types.getPulseSurveySchedulesSuccess:
      return payload.data;
    default:
      return state;
  }
};

const activePulseSurvey = (state = null, { type, payload }) => {
  switch (type) {
    case types.getActivePulseSurveySuccess:
      return payload.data || null;
    case types.storePulseSurveyResponseSuccess:
      return null;
    default:
      return state;
  }
};

const activePulseSurveyFetchedAt = (state = null, { type }) => {
  switch (type) {
    case types.getActivePulseSurveySuccess:
      return new Date();
    default:
      return state;
  }
};

const pulse = combineReducers({
  allPulseSurveys,
  departments,
  locations,
  pulseScales,
  allPulseSurveyResponses,
  pulseSurveyPeriods,
  pulseSurveySchedules,
  allPulseSurveyDetailedAnalytics,
  activePulseSurvey,
  activePulseSurveyFetchedAt,
});

export default { pulse };
